import RewardsPage from './views/RewardsPage.vue';

export default [
  {
    path: '/rewards',
    name: 'rewards',
    component: RewardsPage,
    meta: {
      title: 'Mes Récompenses',
      headerVisible: true,
      headerColor: 'ffffff',
      requiresAuth: true
    }
  }
];
